/**
 * @file: 剪切
 * @author: xiaolong.huang@dmall.com
 */

import Remove from '../remove/index';
import Select from '../select/index';
import History from '../history/index';
import { copy } from './copy';
import { findCopyTarget } from './findCopyTarget';
import { sortCopyList } from './sortCopyList';

function cut(): void {
    let allSelected: Array<CubeId> = Select.getAll();
    if (!allSelected.length) {
        return;
    }
    let cutTargets: CubeId[] = findCopyTarget(allSelected);

    // 复用复制逻辑
    copy();
    History.stackIn({
        type: 'remove',
        data: cutTargets
    });
    Remove.del(cutTargets);
    Select.panelSelectAsync();
}

export {
    cut
};
